import { PositionSetConfig } from "../../components";

export const smallDimensionsFull = { width: 100, height: 65 };
export const smallDimensionsHalf = { width: 50, height: 65 };
export const smallDimensionsGoal = { width: 25, height: 65 };
export const standardDimensionsFull = { width: 120, height: 75 };
export const standardDimensionsHalf = { width: 60, height: 75 };
export const standardDimensionsGoal = { width: 30, height: 75 };

interface Dimensions {
  width: number;
  height: number;
}

export const formation343 = ({ width, height }: Dimensions): PositionSetConfig => {
  return {
    label: "3-4-3",
    fieldSize: "FULL",
    positions: [
      { label: "GK", playerIdNumber: 11, pos: { x: 3, y: height / 2 } },
      { label: "CB", playerIdNumber: 1, pos: { x: width * 0.2, y: height / 2 - 20 } },
      { label: "CB", playerIdNumber: 2, pos: { x: width * 0.22, y: height / 2 } },
      { label: "CB", playerIdNumber: 3, pos: { x: width * 0.2, y: height / 2 + 20 } },
      { label: "LM", playerIdNumber: 4, pos: { x: width * 0.5, y: height / 2 - 28.5 } },
      { label: "CM", playerIdNumber: 5, pos: { x: width * 0.45, y: height / 2 - 10 } },
      { label: "CM", playerIdNumber: 6, pos: { x: width * 0.45, y: height / 2 + 10 } },
      { label: "RM", playerIdNumber: 7, pos: { x: width * 0.5, y: height / 2 + 28.5 } },
      { label: "LW", playerIdNumber: 8, pos: { x: width * (3 / 4), y: height / 2 - 15 } },
      { label: "RW", playerIdNumber: 9, pos: { x: width * (3 / 4), y: height / 2 + 15 } },
      { label: "ST", playerIdNumber: 10, pos: { x: width * 0.9, y: height / 2 } },
    ],
  };
};

export const formation352 = ({ width, height }: Dimensions): PositionSetConfig => ({
  label: "3-5-2",
  fieldSize: "FULL",
  positions: [
    { label: "GK", playerIdNumber: 11, pos: { x: 3, y: height / 2 } },
    { label: "CB", playerIdNumber: 1, pos: { x: width * 0.2, y: height / 2 - 20 } },
    { label: "CB", playerIdNumber: 2, pos: { x: width * 0.22, y: height / 2 } },
    { label: "CB", playerIdNumber: 3, pos: { x: width * 0.2, y: height / 2 + 20 } },
    { label: "LWB", playerIdNumber: 4, pos: { x: width * 0.5, y: height / 2 - 23.5 } },
    { label: "CM", playerIdNumber: 5, pos: { x: width * 0.5, y: height / 2 - 10 } },
    { label: "DM", playerIdNumber: 6, pos: { x: width * 0.4, y: height / 2 } },
    { label: "CM", playerIdNumber: 7, pos: { x: width * 0.5, y: height / 2 + 10 } },
    { label: "RWB", playerIdNumber: 8, pos: { x: width * 0.5, y: height / 2 + 23.5 } },
    { label: "RS", playerIdNumber: 9, pos: { x: width * 0.8, y: height / 2 - 8 } },
    { label: "LS", playerIdNumber: 10, pos: { x: width * 0.8, y: height / 2 + 8 } },
  ],
});

export const formation41212 = ({ width, height }: Dimensions): PositionSetConfig => ({
  label: "4-1-2-1-2",
  fieldSize: "FULL",
  positions: [
    { label: "GK", playerIdNumber: 11, pos: { x: 3, y: height / 2 } },
    { label: "LB", playerIdNumber: 1, pos: { x: width * 0.22, y: height / 2 - 24.5 } },
    { label: "CB", playerIdNumber: 2, pos: { x: width * 0.22, y: height / 2 - 8 } },
    { label: "CDM", playerIdNumber: 3, pos: { x: width * 0.35, y: height / 2 } },
    { label: "CB", playerIdNumber: 4, pos: { x: width * 0.22, y: height / 2 + 8 } },
    { label: "RB", playerIdNumber: 5, pos: { x: width * 0.22, y: height / 2 + 24.5 } },
    { label: "LM", playerIdNumber: 6, pos: { x: width * 0.5, y: height / 2 - 27.5 } },
    { label: "CAM", playerIdNumber: 7, pos: { x: width * 0.75, y: height / 2 } },
    { label: "RM", playerIdNumber: 8, pos: { x: width * 0.5, y: height / 2 + 27.5 } },
    { label: "ST", playerIdNumber: 9, pos: { x: width * 0.9, y: height / 2 - 10 } },
    { label: "ST", playerIdNumber: 10, pos: { x: width * 0.9, y: height / 2 + 10 } },
  ],
});

export const formation4231 = ({ width, height }: Dimensions): PositionSetConfig => ({
  label: "4-2-3-1",
  fieldSize: "FULL",
  positions: [
    { label: "GK", playerIdNumber: 11, pos: { x: 3, y: height / 2 } },
    { label: "LB", playerIdNumber: 1, pos: { x: width * 0.22, y: height / 2 - 24.5 } },
    { label: "CB", playerIdNumber: 2, pos: { x: width * 0.22, y: height / 2 - 8 } },
    { label: "CB", playerIdNumber: 3, pos: { x: width * 0.22, y: height / 2 + 8 } },
    { label: "RB", playerIdNumber: 4, pos: { x: width * 0.22, y: height / 2 + 24.5 } },
    { label: "DM", playerIdNumber: 5, pos: { x: width * 0.45, y: height / 2 - 8 } },
    { label: "DM", playerIdNumber: 6, pos: { x: width * 0.45, y: height / 2 + 8 } },
    { label: "LM", playerIdNumber: 7, pos: { x: width * 0.7, y: height / 2 - 24.5 } },
    { label: "AM", playerIdNumber: 8, pos: { x: width * 0.7, y: height / 2 } },
    { label: "RM", playerIdNumber: 9, pos: { x: width * 0.7, y: height / 2 + 24.5 } },
    { label: "ST", playerIdNumber: 10, pos: { x: width * 0.9, y: height / 2 } },
  ],
});

export const formation433 = ({ width, height }: Dimensions): PositionSetConfig => ({
  label: "4-3-3",
  fieldSize: "FULL",
  positions: [
    { label: "GK", playerIdNumber: 11, pos: { x: 3, y: height / 2 } },
    { label: "LB", playerIdNumber: 1, pos: { x: width * 0.24, y: height / 2 - 22.5 } },
    { label: "CB", playerIdNumber: 2, pos: { x: width * 0.22, y: height / 2 - 8.5 } },
    { label: "CB", playerIdNumber: 3, pos: { x: width * 0.22, y: height / 2 + 8.5 } },
    { label: "RB", playerIdNumber: 4, pos: { x: width * 0.24, y: height / 2 + 22.5 } },
    { label: "CM", playerIdNumber: 5, pos: { x: width * 0.5, y: height / 2 - 10 } },
    { label: "DM", playerIdNumber: 6, pos: { x: width * 0.4, y: height / 2 } },
    { label: "CM", playerIdNumber: 7, pos: { x: width * 0.5, y: height / 2 + 10 } },
    { label: "LW", playerIdNumber: 8, pos: { x: width * 0.7, y: height / 2 - 20.5 } },
    { label: "ST", playerIdNumber: 9, pos: { x: width * 0.75, y: height / 2 } },
    { label: "RW", playerIdNumber: 10, pos: { x: width * 0.7, y: height / 2 + 20.5 } },
  ],
});

export const formation4411 = ({ width, height }: Dimensions): PositionSetConfig => ({
  label: "4-4-1-1",
  fieldSize: "FULL",
  positions: [
    { label: "GK", playerIdNumber: 11, pos: { x: 3, y: height / 2 } },
    { label: "LB", playerIdNumber: 1, pos: { x: width * 0.24, y: height / 2 - 22.5 } },
    { label: "CB", playerIdNumber: 2, pos: { x: width * 0.22, y: height / 2 - 7.5 } },
    { label: "CB", playerIdNumber: 3, pos: { x: width * 0.22, y: height / 2 + 7.5 } },
    { label: "RB", playerIdNumber: 4, pos: { x: width * 0.24, y: height / 2 + 22.5 } },
    { label: "LM", playerIdNumber: 5, pos: { x: width * 0.5, y: height / 2 - 21.5 } },
    { label: "CM", playerIdNumber: 6, pos: { x: width * 0.5, y: height / 2 - 10 } },
    { label: "CM", playerIdNumber: 7, pos: { x: width * 0.5, y: height / 2 + 10 } },
    { label: "RM", playerIdNumber: 8, pos: { x: width * 0.5, y: height / 2 + 21.5 } },
    { label: "CF", playerIdNumber: 9, pos: { x: width * 0.75, y: height / 2 } },
    { label: "ST", playerIdNumber: 10, pos: { x: width * 0.9, y: height / 2 } },
  ],
});

export const formation442 = ({ width, height }: Dimensions): PositionSetConfig => ({
  label: "4-4-2",
  fieldSize: "FULL",
  positions: [
    { label: "GK", playerIdNumber: 11, pos: { x: 3, y: height / 2 } },
    { label: "FB", playerIdNumber: 1, pos: { x: width * 0.24, y: height / 2 - 22.5 } },
    { label: "CB", playerIdNumber: 2, pos: { x: width * 0.22, y: height / 2 - 8.5 } },
    { label: "CB", playerIdNumber: 3, pos: { x: width * 0.22, y: height / 2 + 8.5 } },
    { label: "FB", playerIdNumber: 4, pos: { x: width * 0.24, y: height / 2 + 22.5 } },
    { label: "LM", playerIdNumber: 5, pos: { x: width * 0.6, y: height / 2 - 20.5 } },
    { label: "CM", playerIdNumber: 6, pos: { x: width * 0.5, y: height / 2 - 10 } },
    { label: "CM", playerIdNumber: 7, pos: { x: width * 0.5, y: height / 2 + 10 } },
    { label: "RM", playerIdNumber: 8, pos: { x: width * 0.6, y: height / 2 + 20.5 } },
    { label: "CF", playerIdNumber: 9, pos: { x: width * 0.85, y: height / 2 - 12 } },
    { label: "CF", playerIdNumber: 10, pos: { x: width * 0.85, y: height / 2 + 12 } },
  ],
});

export const formation451 = ({ width, height }: Dimensions): PositionSetConfig => ({
  label: "4-5-1",
  fieldSize: "FULL",
  positions: [
    { label: "GK", playerIdNumber: 11, pos: { x: 3, y: height / 2 } },
    { label: "LB", playerIdNumber: 1, pos: { x: width * 0.24, y: height / 2 - 22.5 } },
    { label: "CB", playerIdNumber: 2, pos: { x: width * 0.22, y: height / 2 - 8.5 } },
    { label: "CB", playerIdNumber: 3, pos: { x: width * 0.22, y: height / 2 + 8.5 } },
    { label: "RB", playerIdNumber: 4, pos: { x: width * 0.24, y: height / 2 + 22.5 } },
    { label: "LM", playerIdNumber: 5, pos: { x: width * 0.5, y: height / 2 - 26 } },
    { label: "CM", playerIdNumber: 6, pos: { x: width * 0.5, y: height / 2 - 10 } },
    { label: "DM", playerIdNumber: 7, pos: { x: width * 0.4, y: height / 2 } },
    { label: "CM", playerIdNumber: 8, pos: { x: width * 0.5, y: height / 2 + 10 } },
    { label: "RM", playerIdNumber: 9, pos: { x: width * 0.5, y: height / 2 + 26 } },
    { label: "ST", playerIdNumber: 10, pos: { x: width * 0.75, y: height / 2 } },
  ],
});

export const formation532 = ({ width, height }: Dimensions): PositionSetConfig => ({
  label: "5-3-2",
  fieldSize: "FULL",
  positions: [
    { label: "GK", playerIdNumber: 11, pos: { x: 3, y: height / 2 } },
    { label: "LWB", playerIdNumber: 1, pos: { x: width * 0.24, y: height / 2 - 28.5 } },
    { label: "CB", playerIdNumber: 2, pos: { x: width * 0.22, y: height / 2 - 20 } },
    { label: "CB", playerIdNumber: 3, pos: { x: width * 0.22, y: height / 2 } },
    { label: "CB", playerIdNumber: 4, pos: { x: width * 0.22, y: height / 2 + 20 } },
    { label: "RWB", playerIdNumber: 5, pos: { x: width * 0.24, y: height / 2 + 28.5 } },
    { label: "CM", playerIdNumber: 6, pos: { x: width * 0.5, y: height / 2 - 13.5 } },
    { label: "CM", playerIdNumber: 7, pos: { x: width * 0.5, y: height / 2 } },
    { label: "CM", playerIdNumber: 8, pos: { x: width * 0.5, y: height / 2 + 13.5 } },
    { label: "ST", playerIdNumber: 9, pos: { x: width * 0.8, y: height / 2 - 6 } },
    { label: "ST", playerIdNumber: 10, pos: { x: width * 0.8, y: height / 2 + 6 } },
  ],
});

export const formation541 = ({ width, height }: Dimensions): PositionSetConfig => ({
  label: "5-4-1",
  fieldSize: "FULL",
  positions: [
    { label: "GK", playerIdNumber: 11, pos: { x: 3, y: height / 2 } },
    { label: "LWB", playerIdNumber: 1, pos: { x: width * 0.24, y: height / 2 - 28.5 } },
    { label: "CB", playerIdNumber: 2, pos: { x: width * 0.22, y: height / 2 - 20 } },
    { label: "CB", playerIdNumber: 3, pos: { x: width * 0.22, y: height / 2 } },
    { label: "CB", playerIdNumber: 4, pos: { x: width * 0.22, y: height / 2 + 20 } },
    { label: "RWB", playerIdNumber: 5, pos: { x: width * 0.24, y: height / 2 + 28.5 } },
    { label: "LM", playerIdNumber: 6, pos: { x: width * 0.55, y: height / 2 - 28.5 } },
    { label: "CM", playerIdNumber: 7, pos: { x: width * 0.45, y: height / 2 - 10.5 } },
    { label: "CM", playerIdNumber: 8, pos: { x: width * 0.45, y: height / 2 + 10.5 } },
    { label: "RM", playerIdNumber: 9, pos: { x: width * 0.55, y: height / 2 + 28.5 } },
    { label: "ST", playerIdNumber: 10, pos: { x: width * 0.8, y: height / 2 } },
  ],
});

export interface SoccerFormationsProps {
  size: "SMALL" | "STANDARD";
  pitchDimension: "FULL" | "HALF" | "GOAL";
}

export const soccerFormations = ({ size, pitchDimension }: SoccerFormationsProps): PositionSetConfig[] => {
  const dimensions = (() => {
    switch (size) {
      case "SMALL": {
        switch (pitchDimension) {
          case "FULL":
            return smallDimensionsFull;
          case "HALF":
            return smallDimensionsHalf;
          case "GOAL":
            return smallDimensionsGoal;
          default:
            return smallDimensionsFull;
        }
      }
      case "STANDARD": {
        switch (pitchDimension) {
          case "FULL":
            return standardDimensionsFull;
          case "HALF":
            return standardDimensionsHalf;
          case "GOAL":
            return standardDimensionsGoal;
        }
      }
    }
  })();

  return [
    formation343(dimensions),
    formation352(dimensions),
    formation41212(dimensions),
    formation4231(dimensions),
    formation433(dimensions),
    formation4411(dimensions),
    formation442(dimensions),
    formation451(dimensions),
    formation532(dimensions),
    formation541(dimensions),
  ];
};
